// src/pages/AuthPage.js
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function AuthPage() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') await login(form.email, form.password);
      else await register(form);
      window.location.href = '/';
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-logo">
            <svg viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="10" fill="#FF4D00"/>
              <path d="M10 28V16l10-7 10 7v12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="16" y="20" width="8" height="8" rx="1" fill="#fff"/>
            </svg>
          </div>
          <h1>Shoppr</h1>
          <p>Manage your store. Create deals. Drive footfall.</p>
        </div>

        <div className="auth-tabs">
          <button className={mode === 'login' ? 'active' : ''} onClick={() => setMode('login')}>Sign In</button>
          <button className={mode === 'register' ? 'active' : ''} onClick={() => setMode('register')}>Register</button>
        </div>

        <form onSubmit={submit}>
          {mode === 'register' && (
            <>
              <input name="name" placeholder="Your Name" value={form.name} onChange={handle} required autoComplete="name" />
              <input name="phone" placeholder="Phone (optional)" value={form.phone} onChange={handle} autoComplete="tel" />
            </>
          )}
          <input name="email" type="email" placeholder="Email address" value={form.email} onChange={handle} required autoComplete="email" />
          <input name="password" type="password" placeholder="Password" value={form.password} onChange={handle} required autoComplete={mode === 'login' ? 'current-password' : 'new-password'} />
          {error && <p className="auth-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: 4,
              padding: '11px',
              background: loading ? '#55524E' : '#111110',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit',
              transition: 'background 150ms',
            }}
          >
            {loading ? 'Please wait…' : mode === 'login' ? 'Sign In' : 'Create Account'}
          </button>
        </form>
      </div>
    </div>
  );
}
